import { render, staticRenderFns } from "./BottomButtons.vue?vue&type=template&id=39671f4c&scoped=true&"
import script from "./BottomButtons.vue?vue&type=script&lang=js&"
export * from "./BottomButtons.vue?vue&type=script&lang=js&"
import style0 from "./BottomButtons.vue?vue&type=style&index=0&id=39671f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39671f4c",
  null
  
)

export default component.exports